<template>
    <div class="report">
        <table>

            <tr>
                <th class="th-first">TOTAL</th>
                <th class="td-first td-by">${{totalPrice}}</th>
            </tr>

            <tr>
                <td class="th-first">TAX</td>
                <td class="td-first td-by">${{taxPrice}}</td>
            </tr>

            <tr>

                <td class="th-first">AMMDUN DUE</td>
                <td class="td-first total-price">${{priceWithTax}}</td>

            </tr>

        </table>

    </div>

</template>

<script>
    export default {
        props: {
            totalPrice: {},
            priceWithTax: {},
            taxPrice:{}
        }
    }
</script>

<style scoped>


    .th-first {
        text-align: left;
    }

    .report {
        padding-bottom: 20px;

        background-image: linear-gradient(to right top,rgba(0,0,0,0.05),rgba(0,0,0,0));

        display: flex;
        justify-content: right;
        color: #111;
    }

    .td-by {
        font-size: 12px;
    }


    .total-price {
        font-size: 18px;
        color: rgb(197, 17, 17);

    }


    th {
        font-weight: bold;
        font-size: 11px;
        padding-bottom: 3px;
        text-align: left;
    }

    td {
        font-weight: bold;
        font-size: 11px;
        text-align: left;
    }


    table {
        width: 40%;
    }

</style>